import { useEffect, useRef, useState } from "react";
import { Col, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Api } from "../Services/CohortServices";
import { useNavigate } from "react-router-dom";
import { MainContainer } from "../Components/MainContainer";
import { TCohortReceive } from "../Types/CohortReceiveType";
import "../Styles/CohortCardsStyle.css"
import { SearchBarComponent } from "../Components/SearchBarComponent";
import { FormatCurrency } from "../Utils/FormatCurrency";
import { NormalizarNome } from "../Utils/NormalizeName";



export const Dashboard = () => {
  const [cohorts, setCohorts] = useState<TCohortReceive[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  //eslint-disable-next-line
  const [filteredCohorts, setFilteredCohorts] = useState<TCohortReceive[]>([]);
  const navigate = useNavigate();

  const scrollContainer = useRef<HTMLDivElement>(null);
  const handleWheelScroll = (event: { preventDefault: () => void; deltaY: any; }) => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollLeft += event.deltaY;
    }
  };

  const fetchCohorts = async () => {
    setLoading(true);
    try {
      const response = await Api.get('/clientsByCohort');
      setCohorts(response.data);
    } catch (error) {
      setError("Não houve retorno do servidor, tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    fetchCohorts();

    return () => {
      controller.abort();
    };
  }, []);


  const handleCohortClick = async (cohortId: number) => {
    // Lógica para redirecionar para a página de detalhes do cohort
    navigate(`/cohorts/${cohortId}`);
  };

  const [clientOnClick, setClientOnClick] = useState<number | boolean>(false);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Os meses começam do zero
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <MainContainer>
      <>
        <div className="main-content">
          <div className="mt-1">
            <Col md={10}>
              <div className="page_title">Cohorts - Visão Geral</div>
              <div className="page_subtitle">Para mais informações clique no corhort ou acesse pagina de cohorts</div>
              <SearchBarComponent
                searchPlaceholder="Pesquisar por CPF ou Tag"
                buttonName="Criar Cohort"
                buttonRoute="/createcohort"
                setFilteredClient={setFilteredCohorts}
                isLoading={setLoading}
              />
              {loading ? (
                <p className="d-flex align-items-center mt-4">Carregando...</p>
              ) : error ? (
                <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>
              ) : (
                <div
                  ref={scrollContainer}
                  className="overflow-auto cohort-container"
                  onWheel={handleWheelScroll}
                >
                  <Row className="d-flex flex-nowrap">
                    {cohorts &&
                      cohorts.map((cohort) => (
                        <Col md={3} key={cohort.cohortId} className="mt-4 p-0">
                          <div className="cohort_main_card">
                            <div className="cohort_card_header" id="TagInfo" onClick={() => handleCohortClick(cohort.cohortId)}>
                              <div>Tag {cohort.cohortTag}</div>
                            </div>
                            <div className="p-1">
                              <ListGroup>
                                {cohort.clients && cohort.clients.slice(0, 10).map((client) =>{ 
                                  return (
                                  <ListGroupItem
                                    key={client.ID}
                                    className="client-item"
                                    onClick={() => setClientOnClick(clientOnClick === client.ID ? false : client.ID)}
                                  >
                                    <div className="client-cpf" style={{ cursor: "pointer" }} >CPF: <span>{client.CPF}</span></div>
                                    {clientOnClick === client.ID && (
                                      <Modal centered={true} isOpen={!!clientOnClick} toggle={() => setClientOnClick(!clientOnClick)}>
                                        <ModalHeader className="client-modal-header">
                                          <strong>Cliente</strong>
                                        </ModalHeader>
                                        <ModalBody className="client-tooltip">
                                          <p><strong>Nome:</strong> {NormalizarNome(client.Nome)}</p>
                                          <p><strong>Telefone:</strong> {client.Telefone}</p>
                                          <p><strong>Saldo:</strong> {FormatCurrency(client.Saldo)}</p>
                                          <p><strong>Aniversário:</strong> {formatDate(client.DataAniversario)}</p>
                                        </ModalBody>
                                      </Modal>
                                    )}
                                  </ListGroupItem>)
                                })}
                                {!cohort.clients && (
                                  <div className="clients_list">Sem Clientes.</div>
                                )}
                              </ListGroup>
                            </div>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </div>
              )}

            </Col>
          </div>
        </div>
      </>
    </MainContainer>
  );
};

